if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (document.querySelector('.sticky-cta')) {
          this.init();
        } else {
          window.initScriptOnDemand(this, this.init.bind(this), 100);
        }
      }

      init() {
        this.form = this.querySelector('form');

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items');
        this.cartNotification = document.querySelector('cart-notification');

        this.submitButton = this.querySelector('[type="submit"]');

        this.ctaButton = !this.closest('.section-featured-product')
          ? this.closest('.section')?.querySelector('.sticky-cta .button')
          : null;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.ctaButton) {
          this.ctaButtonListener =
            this.ctaButtonListener ||
            this.ctaButtonClickHandler.bind(this);

          this.ctaButton.addEventListener(
            'click',
            this.ctaButtonListener
          );
        }

        if (this.cartDrawer) {
          customElements
            .whenDefined('cart-drawer')
            .then(() => {
              this.cartDrawer.init();
            });
        }

        if (this.cartNotification) {
          customElements
            .whenDefined('cart-notification')
            .then(() => {
              this.cartNotification.init();
            });
        }
      }

      disconnectedCallback() {
        if (this.ctaButton) {
          this.ctaButton.removeEventListener(
            'click',
            this.ctaButtonListener
          );
        }
      }

      ctaButtonClickHandler(event) {
        if (this.ctaButton?.closest('.sticky-cta--select-options')) {
          event?.preventDefault();
          return;
        }

        if (
          this.submitButton &&
          this.submitButton.classList.contains('product-form__submit')
        ) {
          this.submitButton.click();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        this.querySelector('.loading__spinner')?.classList.remove(
          'hidden',
          'spinning-complete'
        );

        if (this.ctaButton) {
          this.ctaButton.setAttribute(
            'aria-disabled',
            true
          );

          this.ctaButton
            .querySelector('.loading__spinner')
            ?.classList.remove(
              'hidden',
              'spinning-complete'
            );

          this.ctaButton.classList.add('loading');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        delete config.headers['Content-Type'];

        if (!this.isCustomilyActive()) {
          this.form
            .querySelectorAll(
              'input[name*="customily"], input[name*="_customily"]'
            )
            .forEach((input) => input.remove());
        }

        const formData = new FormData(this.form);

        if (!this.isCustomilyActive()) {
          for (const key of Array.from(formData.keys())) {
            if (key.toLowerCase().includes('customily')) {
              formData.delete(key);
            }
          }
        }

        const selectedAddonItems =
          this.getSelectedAddonItems(formData);

        /*
          Sections that need to be refreshed after cart/add.
        */
        let sections = [];

        if (this.cartDrawer) {
          sections = this.cartDrawer
            .getSectionsToRender()
            .map((section) => section.id);
        }

        if (this.cartNotification) {
          window.loadTemplateContent(
            this.cartNotification
          );

          const cartNotificationSections =
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id);

          sections = [
            ...sections,
            ...cartNotificationSections,
          ];
        }

        if (this.cartItems) {
          const cartItemsSections =
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section);

          sections = [
            ...sections,
            ...cartItemsSections,
          ];
        }

        if (sections.length > 0) {
          formData.append(
            'sections',
            [...new Set(sections)]
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          if (
            theme.settings.cartDrawer.atcAction === 'drawer' &&
            this.cartDrawer
          ) {
            this.cartDrawer.setActiveElement(
              document.activeElement
            );
          } else if (
            theme.settings.cartDrawer.atcAction === 'notification' &&
            this.cartNotification
          ) {
            this.cartNotification.setActiveElement(
              document.activeElement
            );
          }
        }

        if (selectedAddonItems.length > 0) {
          const mainItem =
            this.buildMainCartItem(formData);

          const bundleId =
            'b_' +
            Date.now() +
            '_' +
            Math.random().toString(36).substring(2, 8);

          if (mainItem) {
            mainItem.properties = mainItem.properties || {};
            mainItem.properties._bundle_id = bundleId;
            mainItem.properties._is_bundle_parent = 'true';
            if (this.isCustomilyActive()) {
              mainItem.properties._is_customily = 'true';
            }
          }

          selectedAddonItems.forEach((addon) => {
            addon.properties = addon.properties || {};
            addon.properties._bundle_id = bundleId;
            addon.properties._is_bundle_child = 'true';
            addon.properties._volvik_add_on = 'true';
          });

          const items = [
            mainItem,
            ...selectedAddonItems,
          ].filter(Boolean);

          config.headers['Content-Type'] =
            'application/json';

          const uniqueSections = [
            ...new Set(sections),
          ];

          config.body = JSON.stringify({
            items,

            ...(uniqueSections.length > 0
              ? {
                 
                  sections:
                    uniqueSections.join(','),

                  sections_url:
                    window.location.pathname,
                }
              : {}),
          });
        } else {
          
          config.body = formData;
        }

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => response.json())

          .then((response) => {
            /*
              Shopify returned an error.
            */
            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              if (this.cartDrawer) {
                this.cartDrawer.reload();
              }

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButton
                .querySelector('span')
                .classList.add('hidden');

              if (this.ctaButton) {
                this.ctaButton.setAttribute(
                  'aria-disabled',
                  true
                );

                this.ctaButton
                  .querySelector('span')
                  .classList.add('hidden');
              }

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
              Cart setting redirects to cart page.
            */
            if (
              theme.settings.cartDrawer.atcAction === 'page'
            ) {
              window.location =
                window.routes.cart_url;

              return;
            }

            /*
              Main cart fallback.
            */
            if (
              response.sections === null &&
              document.querySelector('.section-main-cart')
            ) {
              window.location.reload();
            }

            /*
              Native Ignite cart update event.
            */
            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  cartData: response,
                }
              );
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

           
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cartDrawer) {
                      this.cartDrawer.renderContents(
                        response
                      );
                    }

                    if (this.cartItems) {
                      this.cartItems.renderContents(
                        response
                      );
                    }

                    if (
                      this.cartNotification
                    ) {
                      this.cartNotification.renderContents(
                        response
                      );
                    }
                  });
                },
                {
                  once: true,
                }
              );

              if (
                !theme.settings.cartDrawer
                  .muteNotification
              ) {
                quickAddModal.hide(true);
              }
            } else {
              /*
                Normal PDP.
              */
              if (this.cartDrawer) {
                this.cartDrawer.renderContents(
                  response
                );
              }

              if (this.cartItems) {
                this.cartItems.renderContents(
                  response
                );
              }

              if (this.cartNotification) {
                this.cartNotification.renderContents(
                  response
                );
              }
            }

            this.syncCustomHeaderCartBubble(
              response
            );

            this.ctaButton?.classList.add(
              'added-to-cart'
            );

            this.submitButton.classList.add(
              'added-to-cart'
            );
          })

          .catch((error) => {
            console.error(error);
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cartDrawer &&
              this.cartDrawer.classList.contains(
                'is-empty'
              )
            ) {
              this.cartDrawer.classList.remove(
                'is-empty'
              );
            }

            if (
              this.cartNotification &&
              this.cartNotification.classList.contains(
                'is-empty'
              )
            ) {
              this.cartNotification.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            setTimeout(() => {
              this.ctaButton?.classList.remove(
                'added-to-cart'
              );

              this.submitButton.classList.remove(
                'added-to-cart'
              );
            }, 1000);

            if (this.ctaButton) {
              this.ctaButton.classList.remove(
                'loading'
              );

              if (!this.error) {
                this.ctaButton.removeAttribute(
                  'aria-disabled'
                );
              }

              this.ctaButton
                .querySelector('.loading__spinner')
                ?.classList.add(
                  'hidden',
                  'spinning-complete'
                );
            }

            this.querySelector(
              '.loading__spinner'
            )?.classList.add(
              'hidden',
              'spinning-complete'
            );

            publish(
              'quick-buy-action-complete'
            );
          });
      }

      syncCustomHeaderCartBubble(
        parsedState
      ) {
      
        const sectionHtml =
          parsedState?.sections?.[
            'cart-icon-bubble'
          ];

        if (!sectionHtml) {
          return;
        }

        const parsedSection =
          new DOMParser().parseFromString(
            sectionHtml.replace(
              /<template\b[^>]*>|<\/template>/g,
              ''
            ),
            'text/html'
          );

        const sourceCount =
          parsedSection.querySelector(
            '.cart-count-bubble'
          );

        const customCartLinks =
          document.querySelectorAll(
            '.custom-header [id="cart-icon-bubble"]'
          );

        if (!customCartLinks.length) {
          return;
        }

        customCartLinks.forEach(
          (cartLink) => {
            let targetCount =
              cartLink.querySelector(
                '.cart-count-bubble'
              );

          
            if (!sourceCount) {
              targetCount?.remove();

              return;
            }

            if (!targetCount) {
              targetCount =
                sourceCount.cloneNode(true);

              cartLink.appendChild(
                targetCount
              );

              return;
            }

          
            targetCount.innerHTML =
              sourceCount.innerHTML;

            if (
              sourceCount.hasAttribute(
                'style'
              )
            ) {
              targetCount.setAttribute(
                'style',
                sourceCount.getAttribute(
                  'style'
                )
              );
            } else {
              targetCount.removeAttribute(
                'style'
              );
            }
          }
        );
      }

      isCustomilyActive() {
        try {
          const productWrapper =
            this.closest('.product') ||
            this.closest('.product-info') ||
            this.closest('section') ||
            document;

          const hasCustomilyUI =
            productWrapper.querySelector(
              '#customily-personalize-button, .customily-personalize-button, .customily_gallery, #customily-options, .customily-options, .customily_options'
            ) !== null;

          if (!hasCustomilyUI) {
            return false;
          }

          const customilyInputs = Array.from(
            this.form.querySelectorAll(
              'input[name*="customily"], input[name*="_customily"]'
            )
          );

          if (!customilyInputs.length) {
            return false;
          }

          return customilyInputs.some((input) => {
            const val = (input.value || '').trim();
            return val !== '' && val !== 'null' && val !== 'undefined';
          });
        } catch (e) {
          return false;
        }
      }

      getSelectedAddonItems(
        formData
      ) {
        if (!this.form?.id) {
          return [];
        }
        const checkedAddons =
          Array.from(
            document.querySelectorAll(
              '[data-addon-checkbox]:checked:not(:disabled)'
            )
          ).filter(
            (checkbox) => {
              const linkedFormId =
                checkbox.getAttribute(
                  'form'
                ) ||
                checkbox.dataset
                  .addonFormId ||
                '';

              return (
                linkedFormId ===
                this.form.id
              );
            }
          );

        const idsFromFormData =
          formData
            ? formData
                .getAll(
                  '_volvik_addon_variant_ids[]'
                )
                .map((value) =>
                  String(value)
                )
            : [];

        const selectedById =
          new Map();

        checkedAddons.forEach(
          (checkbox) => {

            if (
              checkbox.dataset
                .addonBaseProduct ===
              'true'
            ) {
              return;
            }

            const id = Number(
              checkbox.dataset
                .addonVariantId ||
                checkbox.value
            );

            if (
              !Number.isFinite(id) ||
              id <= 0
            ) {
              return;
            }

            selectedById.set(
              String(id),
              {
                id,

                quantity: 1,

                properties: {
                  _volvik_add_on:
                    'true',

                  _add_on_discount:
                    String(
                      Math.max(
                        0,
                        Number(
                          checkbox
                            .dataset
                            .addonDiscount
                        ) || 0
                      )
                    ),

                  _add_on_name:
                    checkbox.dataset
                      .addonTitle ||
                    '',
                },
              }
            );
          }
        );

        idsFromFormData.forEach(
          (rawId) => {
            const id =
              Number(rawId);

            if (
              !Number.isFinite(id) ||
              id <= 0 ||
              selectedById.has(
                String(id)
              )
            ) {
              return;
            }

            selectedById.set(
              String(id),
              {
                id,

                quantity: 1,

                properties: {
                  _volvik_add_on:
                    'true',
                },
              }
            );
          }
        );

        return Array.from(
          selectedById.values()
        );
      }

      buildMainCartItem(
        formData
      ) {
        const id = Number(
          formData.get('id')
        );

        if (
          !Number.isFinite(id) ||
          id <= 0
        ) {
          return null;
        }

        const quantity =
          Math.max(
            1,
            Number(
              formData.get(
                'quantity'
              )
            ) || 1
          );

        const mainItem = {
          id,
          quantity,
        };

        const sellingPlan =
          formData.get(
            'selling_plan'
          );

        if (sellingPlan) {
          mainItem.selling_plan =
            Number(
              sellingPlan
            ) || sellingPlan;
        }

        const properties = {};
        const isCustom = this.isCustomilyActive();

        for (
          const [
            key,
            value,
          ] of formData.entries()
        ) {
          const match =
            key.match(
              /^properties\[(.+)\]$/
            );

          if (
            !match ||
            value === '' ||
            value == null
          ) {
            continue;
          }

          const propKey = match[1];

          if (!isCustom && propKey.toLowerCase().includes('customily')) {
            continue;
          }

          properties[
            propKey
          ] = value;
        }

        if (
          Object.keys(
            properties
          ).length > 0
        ) {
          mainItem.properties =
            properties;
        }

        return mainItem;
      }


      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;

          const elementRect =
            this.errorMessage.getBoundingClientRect();

          const isVisible =
            elementRect.top >= 0 &&
            elementRect.bottom <=
              window.innerHeight &&
            elementRect.top >= 100;

          if (!isVisible) {
            const topPosition =
              elementRect.top +
              window.pageYOffset -
              150;

            window.scrollTo({
              top: topPosition,
              behavior: 'smooth',
            });
          }
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        let price;

        if (
          this.form.dataset
            .showPrice === 'true'
        ) {
          const productInfo =
            this.form.closest(
              '.product__info-wrapper'
            );

          const priceElem =
            productInfo?.querySelector(
              '.price__container .price-item--last'
            );

          const priceText =
            priceElem?.textContent.trim();

          if (
            priceText &&
            priceText.length > 0
          ) {
            price = priceText;
          }
        }

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          this.ctaButton?.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButton.querySelector(
              'span'
            ).textContent =
              `${text}${
                price
                  ? ' - ' + price
                  : ''
              }`;

            if (this.ctaButton) {
              this.ctaButton.querySelector(
                'span'
              ).textContent =
                text;
            }
          }

          if (
            text ===
            window.variantStrings
              .soldOut
          ) {
            this.closest(
              '.product'
            )?.setAttribute(
              'data-variant-status',
              'out-of-stock'
            );
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.ctaButton?.removeAttribute(
            'disabled'
          );

          const buttonText =
            this.submitButton.dataset
              .isPreorder
              ? window.variantStrings
                  .preorder
              : window.variantStrings
                  .addToCart;

          this.submitButton.querySelector(
            'span'
          ).textContent =
            `${buttonText}${
              price
                ? ' - ' + price
                : ''
            }`;

          if (this.ctaButton) {
            this.ctaButton.querySelector(
              'span'
            ).textContent =
              buttonText;
          }

          this.closest(
            '.product'
          )?.setAttribute(
            'data-variant-status',
            'in-stock'
          );
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}
